export const normalizeName = (name: string): string =>
  name.split(' ')[0].toLowerCase().trim()
